import{createContext}from"react";const NavigationContext=createContext({activeSubmenu:null,setActiveSubmenu:()=>{}});export default NavigationContext;